import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"
import { del } from "../../helpers/api_helper"
//redux
import { useNavigate, useParams } from "react-router-dom"
import { REMOVE_EMERGENCY_TYPES } from "helpers/api_endpoints"

function RemoveEmergencyType() {
  const history = useNavigate()
  const params = useParams()
  const id = params.id
  const navigate = useNavigate()

  useEffect(() => {
    del(REMOVE_EMERGENCY_TYPES, { id })
      .then(response => {
        navigate("/emergency-types", {
          state: { successMsg: "Emergency Type Deleted Successfully" },
        })
      })
      .catch(error => {
        console.log(error)
      })
  })
  return <React.Fragment>Removed</React.Fragment>
}

export default RemoveEmergencyType
